import { BrowserRouter, Route, Routes } from "react-router-dom";
import Validate from "./screens/validate/Validate";
import { ViewDetails } from "./screens/view/ViewDetails";
import MelcoAccountFlowLayout from "./components/layout/MelcoAccountFlowLayout";

export const Main: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path=""
          element={
            <MelcoAccountFlowLayout>
              <Validate />
            </MelcoAccountFlowLayout>
          }
        />
        <Route
          path="view"
          element={<ViewDetails />}
        />
      </Routes>
    </BrowserRouter>
  );
};
